import path from 'node:path';

export type CodeNavLanguageSpec = {
  wasmFile: string;
  tagsQueryFile: string;
};

const EXT_TO_LANGUAGE_KEY: Record<string, string> = {
  js: 'javascript',
  jsx: 'javascript',
  mjs: 'javascript',
  cjs: 'javascript',
  ts: 'typescript',
  tsx: 'tsx',
  py: 'python',
  go: 'go',
  rs: 'rust',
  rb: 'ruby',
  java: 'java',
  c: 'c',
  h: 'c',
  cpp: 'cpp',
  cc: 'cpp',
  cxx: 'cpp',
  hpp: 'cpp',
};

function languageAssetPaths(key: string, wasmFile: string): CodeNavLanguageSpec {
  return {
    wasmFile,
    tagsQueryFile: `tree-sitter-${key}/tags.scm`,
  };
}

const LANGUAGE_SPECS: Record<string, CodeNavLanguageSpec> = {
  javascript: languageAssetPaths('javascript', 'tree-sitter-javascript.wasm'),
  typescript: languageAssetPaths('typescript', 'tree-sitter-typescript.wasm'),
  tsx: languageAssetPaths('typescript', 'tree-sitter-tsx.wasm'),
  python: languageAssetPaths('python', 'tree-sitter-python.wasm'),
  go: languageAssetPaths('go', 'tree-sitter-go.wasm'),
  rust: languageAssetPaths('rust', 'tree-sitter-rust.wasm'),
  ruby: languageAssetPaths('ruby', 'tree-sitter-ruby.wasm'),
  java: languageAssetPaths('java', 'tree-sitter-java.wasm'),
  c: languageAssetPaths('c', 'tree-sitter-c.wasm'),
  cpp: languageAssetPaths('cpp', 'tree-sitter-cpp.wasm'),
};

export function getLanguageKeyForFilePath(filePath: string): string | null {
  const ext = path.extname(filePath).replace(/^\./, '').toLowerCase();
  if (!ext) return null;
  return EXT_TO_LANGUAGE_KEY[ext] ?? null;
}

export function getLanguageSpec(languageKey: string): CodeNavLanguageSpec | null {
  return LANGUAGE_SPECS[languageKey] ?? null;
}

export function isCodeNavSupportedPath(filePath: string): boolean {
  const key = getLanguageKeyForFilePath(filePath);
  return key != null && getLanguageSpec(key) != null;
}
